export var ScenesServiceErrorCode;
(function (ScenesServiceErrorCode) {
    ScenesServiceErrorCode["OtherError"] = "OtherError";
    ScenesServiceErrorCode["FatalError"] = "FatalError";
    ScenesServiceErrorCode["NoData"] = "NoData";
    ScenesServiceErrorCode["InvalidSceneGuid"] = "InvalidSceneGuid";
})(ScenesServiceErrorCode || (ScenesServiceErrorCode = {}));
//# sourceMappingURL=IScenesService.js.map